// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type StripeAccountsQueryVariables = Types.Exact<{
  restaurantIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type StripeAccountsQuery = { __typename?: 'Query', stripeAccounts: Array<{ __typename?: 'StripeAccount', id: string, displayName?: string | null, requirements: any }> };

export type StripeAccountSessionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type StripeAccountSessionQuery = { __typename?: 'Query', stripeAccountSession: { __typename?: 'AccountSession', clientSecret: string } };


export const StripeAccountsDocument = gql`
    query stripeAccounts($restaurantIds: [ID!]) {
  stripeAccounts(restaurantIds: $restaurantIds) {
    id
    displayName
    requirements
  }
}
    `;

export function useStripeAccountsQuery(options?: Omit<Urql.UseQueryArgs<StripeAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<StripeAccountsQuery, StripeAccountsQueryVariables>({ query: StripeAccountsDocument, ...options });
};
export const StripeAccountSessionDocument = gql`
    query stripeAccountSession($id: ID!) {
  stripeAccountSession(id: $id) {
    clientSecret
  }
}
    `;

export function useStripeAccountSessionQuery(options: Omit<Urql.UseQueryArgs<StripeAccountSessionQueryVariables>, 'query'>) {
  return Urql.useQuery<StripeAccountSessionQuery, StripeAccountSessionQueryVariables>({ query: StripeAccountSessionDocument, ...options });
};